import React, { useCallback } from "react";
import {
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Row,
  Col,
  Switch,
} from "antd";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCustomers } from "../../store/actions/customers";
import { getAllSettings } from "../../store/actions/settings";

const EwayTransactionForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const customers = useSelector((state) => state.customers.list);
  const settings = useSelector((state) => state.settings.list);

  const typeOptions = [
    { id: "EWAY", name: "EWAY" },
    { id: "EINVOICE", name: "EINVOICE" },
  ];

  const handleValuesChange = useCallback(
    (changedValues, allValues) => {
      if (allValues && allValues.type) {
        dispatch(getAllSettings());
      }
      if (allValues.type) {
        const setting =
          Array.isArray(settings) && settings.length > 0 ? settings[0] : null;
        if (allValues) {
          const rate =
            allValues.type === "EWAY"
              ? setting?.ewayRatePerPcs
              : setting?.eInvoiceRatePerPcs;
          form.setFieldValue("ratePerPcs", rate);
        }
      }
      form.setFieldValue(
        "amt",
        Number(allValues?.count || 0) * Number(allValues?.ratePerPcs || 0)
      );
    },
    [form, dispatch, settings]
  );

  useEffect(() => {
    if (record?.id) {
      form.setFieldsValue(record);
    } else {
      form.resetFields();
    }
  }, [form, record, record?.id]);

  useEffect(() => {
    dispatch(getCustomers());
  }, [dispatch]);

  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  return (
    <Modal
      open={visible}
      title={record ? "Update Eway Transaction" : "Add Eway Transaction"}
      okText="Submit"
      cancelText="Cancel"
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onCreate(values);
            form.resetFields();
            onCancel();
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
      width={500}
      centered
      bodyStyle={{ paddingTop: 20 }}
    >
      <Form
        {...formItemLayout}
        form={form}
        layout="vertical"
        name="eWayTransaction_form"
        onValuesChange={handleValuesChange}
      >
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              name="cusId"
              label="Customer"
              rules={[
                {
                  required: true,
                  message: "Please select at least one Customer!",
                },
              ]}
            >
              <Select
                placeholder="Select Customer"
                style={{ width: "100%" }}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {customers?.map((c) => (
                  <Select.Option key={c.id} value={c.id}>
                    {c.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name="type"
              label="Type"
              rules={[
                {
                  required: true,
                  message: "Please select at least one Type!",
                },
              ]}
            >
              <Select
                placeholder="Select Type"
                style={{ width: "100%" }}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {typeOptions.map((product) => (
                  <Select.Option key={product.id} value={product.id}>
                    {product.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="count"
              label="Qty"
              rules={[
                {
                  required: true,
                  message: "Please enter the qty!",
                },
                { type: "number", message: "Must be a valid qty!" },
              ]}
            >
              <InputNumber
                min={0}
                max={100}
                placeholder="Enter qty"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="ratePerPcs"
              label="Rate Per Pcs"
              rules={[
                {
                  required: true,
                  message: "Please enter the Rate Per Pcs!",
                },
                { type: "number", message: "Must be a valid Rate Per Pcs!" },
              ]}
            >
              <InputNumber
                min={0}
                max={100}
                placeholder="Enter Rate Per Pcs"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name="amt"
              label="Amount"
              rules={[
                {
                  required: true,
                  message: "Please enter the Amount",
                },
                { type: "number", message: "Must be a valid Amount!" },
              ]}
            >
              <InputNumber
                min={0}
                max={100}
                placeholder="Enter Amount"
                style={{ width: "100%" }}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EwayTransactionForm;
